import { Channel, ChannelGroupingResult, ChannelType, MaybeChannelGroupingResult } from "./channelgrouping";
import { ParsedUrlParams } from "./urlparams";
import { Utms } from "./utms";


const sources = [
    // 360.cn
    '360.cn',
    // Alice
    'www.alice.com',
    'aliceadsl',
    // Alltheweb
    'www.alltheweb.com',
    // Altavista
    'www.altavista.com',
    // AOL
    'www.aol.com',
    // Ask
    'www.ask.com',
    'search.aol',
    'alicesuche.aol.de',
    // Auone
    'search.auone',
    // Avg
    'isearch.avg.com',
    // Babylon
    'search.babylon.com',
    // Baidu
    'www.baidu.com',
    // Biglobe
    'biglobe.ne.jp',
    // Bing and all related properties
    'bing',
    // Centrum
    'search.centrum.cz',
    // Comcast
    'search.comcast.net',
    // Conduit
    'search.conduit.com',
    // CNN
    'www.cnn.com',
    // Daum
    'www.daum.net',
    // Dog Pile - From GD Source Tracking Plugin
    'dogpile.com',
    // DuckDuckGo
    'duckduckgo.com',
    // Ecosia
    'www.ecosia.org',
    // Ekolay
    'www.ekolay.net',
    // Eniro
    'www.eniro.se',
    // Globo
    'www.globo.com',
    // Go.mail.ru
    'go.mail.ru',
    // all google search domains
    'google',
    // Goo.ne
    'goo.ne.jp',
    // Hausou.com
    'www.haosou.com',
    // Incredimail
    'search.incredimail.com',
    // Kvasir
    'www.kvasir.no',
    // Live - already covered under 'bing'
    // Lycos + regional
    'www.lycos.com',
    'search.lycos',
    'www.mamma.com',
    // MSN + all related properties / subdomains
    'msn.com',
    // MyNet
    'www.mynet.com',
    // Najdi
    'najdi.si',
    // Naver
    'www.naver.com',
    // Netscape
    'search.netscape.com',
    // ONET
    'szukaj.onet.pl',
    // Ozu
    'www.ozu.es',
    // Rakuten
    'rakuten.co.jp',
    // Rambler
    'rambler.ru',
    // Search Results
    'search-results.com',
    // Search.smt.docomo
    'search.smt.docomo.ne.jp',
    // Sesam
    'sesam.no',
    // Sezname
    'www.seznam.cz',
    // So.com
    'www.so.com',
    // Sogou
    'www.sogou.com',
    // Startsiden
    'www.startsiden.no',
    // Szukacz
    'www.szukacz.pl',
    // Terra
    'buscador.terra.com.br',
    // Tut.by
    'search.tut.by',
    // Ukr
    'search.ukr.net',
    // Virgilio
    'search.virgilio.it',
    // Voila
    'www.voi,la.fr',
    // Wirtulana Polska
    'www.wp.pl',
    // YAHOO
    'yahoo.cn',
    'yahoo.com',
    // YANDEX
    'www.yandex.com',
    // YAM
    'www.yam.com',
];

/**
 * string key: the utm source value to query for
 * boolean value: whether it is a "contains" query or not
 */
const AISources: Record<string, boolean> = {
    'chatgpt.com': false,
    'openai.com': false,
    'perplexity': true,
    'gemini.google.com': false,
    'bard.google.com': false,
    'copilot.microsoft.com': false,
    'edgepilot.bing.com': false,
    'edgeservices.bing.com': false,
    'claude.ai': false,
    'meta.ai': false,
    'deepseek.com': false,
    'anthropic.com': false,
    'blackbox.ai': false,
    'poe.com': false,
    'mistral.ai': false,
    'huggingface.co': false,
    'you.com': false,
    'phind.com': false,
    'pi.ai': false,
    'consensus.app': false,
    'iask.ai': false,
    'komo.ai': false,
    'andi.ai': false,
    'forefront.ai': false,
    'arc.net': false,
    'qwen.ai': false,
    'bagoodex.io': false,
    'getmerlin.in': false,
    'khanmigo.ai': false,
    'reka.ai': false,
    'ora.sh': false,
    'writesonic.com': false,
    'ai21.com': false,
    'socratic.org': false,
    'brainly.com': false,
};


export default class OrganicChannel {

    public static is(referrer: string, params: ParsedUrlParams) : MaybeChannelGroupingResult
    {       
        // first - short-circuit based on utms
        const utms = new Utms(params);
        const medium = utms.getMedium();
        const source = utms.getSource();

        // AI organic source
        const aiResult = OrganicChannel.isAi(source);
        if (aiResult) {
            return aiResult;
        }

        // non-AI organic medium
        if (medium === 'organic') {
            return new ChannelGroupingResult(Channel.Organic, ChannelType.Search);
        }

        // lastly, traditional check if the referrer is an organic referral source
        for (let i = 0; i < sources.length; i ++) {
            if (referrer.indexOf(sources[i]) !== -1) {
                return new ChannelGroupingResult(Channel.Organic, ChannelType.Search);
            }
        }
        return null;
    }

    protected static isAi(source: string) : MaybeChannelGroupingResult
    {
        if (source === null) {
            return null;
        }
        const keys = Object.keys(AISources);
        for (let i = 0; i < keys.length; i ++) {
            const key: string = keys[i];
            const useContains: boolean = AISources[key];
            let match : boolean = false;
            if (useContains) {
                match = source.indexOf(key) !== -1;
            } else {
                match = key.toLowerCase() === source.toLowerCase();
            }
            if (match) {
                return new ChannelGroupingResult(Channel.Organic, ChannelType.AI);
            }
        }
        return null;
    }

}
